import { canAccessRole, UserRoleEnum } from '@entities/User';
import { isMerchantTab, MERCHANT_TAB_KEYS } from '@pages/MerchantDashboard';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { MerchantDashboardRoutePage } from './-MerchantDashboardRoutePage';

interface MerchantSearch {
  tab: (typeof MERCHANT_TAB_KEYS)[number];
}

export const Route = createFileRoute('/_app/__auth/merchant/')({
  beforeLoad: ({ context }) => {
    const role = context.auth.user?.role;

    if (
      context.auth.user &&
      !canAccessRole(role, [UserRoleEnum.Merchant, UserRoleEnum.Admin])
    ) {
      throw redirect({ to: '/' });
    }
  },
  component: MerchantDashboardRoutePage,
  validateSearch: (search: Record<string, unknown>): MerchantSearch => {
    const tab =
      typeof search.tab === 'string' ? search.tab : MERCHANT_TAB_KEYS[0];

    return {
      tab: isMerchantTab(tab) ? tab : MERCHANT_TAB_KEYS[0],
    };
  },
});
